import _ from 'underscore';
import $ from 'jquery';
import BulkTransferLightbox from './bulk-transfer-lightbox';
import instrument from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentConsts from '@bingads-webui-static-legacy/instrumentation/constants';
import { getCCUrl } from '@bingads-webui-component-legacy/bingads-grid/shared/clientcenter-url-helper';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/bulk-transfer-accounts');

const transferAccountsUrlConfirmation = 'managers/bulktransferaccountsconfirmation';
const reparentingJobAddUrl = 'reparenting/jobadd';

const reparentingJobAddHandler = ({ customerId, userId, accountIds, successCallback }) => {
  $.advertiser.ajaxPost({
    url: getCCUrl(reparentingJobAddUrl, { cid: customerId, uid: userId }),
    xhrFields: {
      withCredentials: true,
    },
    data: { accountIds },
    traditional: true,
    onSuccess: (data) => successCallback({ reparentingId: data.id }),
  });
};

export default function bulkTransferAccounts({
  selectedAccounts,
  i18n: newI18n,
  customerId,
  userId,
  onSuccessCallBack,
}) {
  // select only Advertiser account entities
  let accounts = _.filter(selectedAccounts, (account) => account.accountType === 'AdAccount');

  accounts = _.map(selectedAccounts, (account) => {
    return {
      id: account.Id,
    };
  });
  const bulkTransferModel = { accounts };
  const transferConfirmationUrl = getCCUrl(transferAccountsUrlConfirmation);

  $.advertiser.ajaxPost({
    url: transferConfirmationUrl,
    xhrFields: {
      withCredentials: true,
    },
    data: {cid: customerId, uid: userId, transferacc: JSON.stringify(bulkTransferModel)},
    onSuccess: (model) => {
      if (model && model.accounts) {
        const accountIds = _.map(model.accounts, (acc) => acc.id);
        const dialogView = new BulkTransferLightbox({
          newI18n,
          accountsCount: accountIds.length,
          errorDetails: model.errorDetails,
          isBlocking: model.isBlocking,
          buttonEvent: () => {
            const successCallback = ({ reparentingId }) => {
              if (_.isFunction(onSuccessCallBack) && _.isNumber(reparentingId)) {
                onSuccessCallBack({
                  accounts: model.accounts,
                  rpid: reparentingId,
                });
              }
            };

            reparentingJobAddHandler({ customerId, userId, accountIds, successCallback });
          },
        });

        dialogView.render();
      }
    },
    onError: (e) => {
      $.advertiser.appendErrorSummary(i18n.getString('GenericErrorMessage_Short'));
      instrument.logMessage(instrumentConsts.LOGCATEGORY.ERROR, instrumentConsts.LOGLEVEL.INFO, `bulktransferaccounts/ajaxPost failed with ${JSON.stringify(e)}`, JSON.stringify(bulkTransferModel));
    },
    hideLoadingPanelOnSuccess: true,
  });
}
